export const MAX_PERSONAL_MEETINGS = 5;

export const MEETING_TITLE_MIN_LENGTH = 1;
export const MEETING_TITLE_MAX_LENGTH = 250;

export const MEETING_ID_MIN_LENGTH = 12;
export const MEETING_ID_MAX_LENGTH = 50;
export const MEETING_ID_ALLOWED = /^[A-Za-z0-9]+$/;

export const PASSCODE_MIN_LENGTH = 4;
export const PASSCODE_MAX_LENGTH = 12;
export const PASSCODE_ALLOWED = /^[0-9]+$/;

export const LOBBY_MESSAGE_MAX_LENGTH = 300;

export const PERSONAL_MEETINGS_MODAL_ID = 'personal-meetings-modal';
export const PERSONAL_MEETING_DESCRIPTION_PREFIX = 'Personal Meeting #';
